import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography, useBreakpoint } from '@one-thd/sui-atomic-components';
import { useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';
import { AssistantIcon } from '../../../assets/AssistantIcon';
import { EntryPointSuggestedQuestions } from '../subcomponents/EntryPointSuggestedQuestions';

export const MASuggestedQuestionsEntry = ({ entryLocationForAnalytics }) => {
  const { isConsumerApp, customer } = useContext(ExperienceContext);
  const { lesser: isMobile } = useBreakpoint('lg');
  const fsEntryPointEnabled = useConfigService('fs:ma-entry-point-enabled');
  const fsDTEnabled = useConfigService('magic-apron-assistant-dt-enabled');
  const fsMWEnabled = useConfigService('magic-apron-assistant-mw-enabled');
  const fsAPPEnabled = useConfigService('magic-apron-assistant-app-enabled');

  const showOnDesktop = fsDTEnabled && !isMobile;
  const showOnMobileWeb = fsMWEnabled && isMobile && !isConsumerApp;
  const showOnApp = fsAPPEnabled && isMobile && isConsumerApp;
  const isChannelSupported = showOnDesktop || showOnMobileWeb || showOnApp;

  const isB2CCustomer = customer?.type === 'b2c';
  const hasRequiredAPIs = typeof BroadcastChannel !== 'undefined'
    && typeof window !== 'undefined'
    && window.LIFE_CYCLE_EVENT_BUS;

  if (
    !fsEntryPointEnabled
    || !isChannelSupported
    || !isB2CCustomer
    || !hasRequiredAPIs
  ) {
    return null;
  }

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <div className="sui-flex sui-flex-col sui-p-4 sui-gap-5 sui-bg-[rgb(254,239,229)]">
      <div className="sui-flex sui-flex-row sui-items-center sui-gap-3">
        <AssistantIcon width="28px" height="32px" />
        <Typography variant="h3">
          Ask Magic Apron
        </Typography>
      </div>
      <EntryPointSuggestedQuestions entryLocationForAnalytics={entryLocationForAnalytics} />
    </div>
  );
};

MASuggestedQuestionsEntry.propTypes = {
  entryLocationForAnalytics: PropTypes.string,
};

MASuggestedQuestionsEntry.defaultProps = {
  entryLocationForAnalytics: '',
};
